'use client';

import { articleService } from '@/services/articleService';
import { useEffect, useState } from 'react';

interface ViewCountProps {
  slug: string;
  host: string;
}

export default function ViewCount({ hidden, slug, host }: ViewCountProps & { hidden?: boolean }) {
  const [viewCount, setViewCount] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchViewCount = async () => {
      try {
        setIsLoading(true);
        const response = await articleService.getArticleViewCount(slug, host);
        if (response?.success && response?.data) {
          setViewCount(response.data.view_count);
        }
      } catch (error) {
        console.error('Error fetching view count:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (slug) {
      fetchViewCount();
    }
  }, [slug, host]);

  if (isLoading || viewCount === null) {
    return null;
  }
    if (hidden || viewCount === null) return null;


  return (
    <>
      <span className="mx-2">|</span>
      <span className="text-xs text-orange">
        {viewCount.toLocaleString()} views
      </span>
    </>
  );
}
